import { createContext, useContext, useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { useUser } from './UserContext';

const UserCountContext = createContext();

export function UserCountProvider({ children }) {
  const { appUserAccountNumber } = useUser();
  const [userCount, setUserCount] = useState(0);

  useEffect(() => {
    if (!appUserAccountNumber) return;

    const usersRef = collection(db, 'appUsers');

    const q = query(
      usersRef,
      where('accountNumber', '==', appUserAccountNumber),
      where('status', 'in', ['active', 'pending']) // Note: Firestore does NOT allow a simple '!=' query on snapshots, It will crash silently or never trigger snapshot updates properly.
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setUserCount(snapshot.size);
    });

    return () => unsubscribe();
  }, [appUserAccountNumber]);

  return (
    <UserCountContext.Provider value={userCount}>
      {children}
    </UserCountContext.Provider>
  );
}

export function useUserCount() {
  return useContext(UserCountContext);
}
